export enum UserRole {
    ROLE_ADMINISTRATOR = 'ROLE_ADMINISTRATOR',
    ROLE_AGENCY_ADMIN = 'ROLE_AGENCY_ADMIN',
    ROLE_AGENT = 'ROLE_AGENT',
    ROLE_UNDER_WRITER = 'ROLE_UNDER_WRITER',
    ROLE_DIRECT_CLIENT = 'ROLE_DIRECT_CLIENT',
    ROLE_ISC = 'ROLE_ISC',
    ROLE_CSE = 'ROLE_CSE',
    ROLE_REGIONAL_ADMIN = 'ROLE_REGIONAL_ADMIN',
    ROLE_BRANCH_MANAGER = 'ROLE_BRANCH_MANAGER'
}

export type EditRoles = Omit<UserRole, 'ROLE_AGENCY_ADMIN' | 'ROLE_AGENT'>;
